class Material {
  constructor(
    public name?: string,
    public description?: string,
    public id?: number | undefined,
    public GUID?: string | undefined
  ) {}

  public static EmptyInstance(): Material {
    return new Material("", "");
  }

  public static Display(material: Material): string {
    return material.name === "Other" && material.description
      ? material.description
      : material.name!;
  }
}

export default Material;
